export default "__VITE_ASSET__ea2c84c3__"